/**
 * Libellés lisibles des codes renvoyés par le serveur (statuts, natures).
 * Un code inconnu est affiché tel quel, sans soulignés.
 */
const LIBELLES = {
  PAYEE: 'Payée',
  PAYE: 'Payé',
  PARTIELLEMENT_PAYEE: 'Partiellement payée',
  IMPAYEE: 'Impayée',
  BROUILLON: 'À payer',
  GRATUITE: 'Gratuite',
  PRISE_EN_CHARGE: 'Prise en charge (cas social)',
  ACTIF: 'Actif',
  ANNULE: 'Annulé',
  ANNULEE: 'Annulée',
  VALIDE: 'Validé',
  REMBOURSE: 'Remboursé',
  FACTURE_SERVICE: 'Facture de services',
  CONSULTATION: 'Consultation',
  HOSPITALISATION: 'Hospitalisation',
  VENTE: 'Vente pharmacie',
  REMBOURSEMENT: 'Remboursement',
  A_FACTURER: 'À facturer',
  A_PAYER: 'Facturé, non payé',
  'Non payée': 'Non payée',
}

export function libelle(code) {
  if (code === null || code === undefined || code === '') return '—'
  const c = String(code)
  return LIBELLES[c] ?? LIBELLES[c.toUpperCase()] ?? c.replace(/_/g, ' ').toLowerCase().replace(/^./, x => x.toUpperCase())
}

export default libelle

/** Nombre décimal à la française (23.5 → « 23,5 »). */
export function decimal(v) {
  if (v === null || v === undefined || v === '') return ''
  return String(v).replace('.', ',')
}

/** Date (et heure) au format JJ/MM/AAAA HH:mm, depuis « 2026-10-24 15:59 » ou ISO. */
export function dateHeureFr(v) {
  if (!v) return ''
  const m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/)
  if (!m) return String(v)
  return `${m[3]}/${m[2]}/${m[1]}` + (m[4] ? ` ${m[4]}:${m[5]}` : '')
}
